var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPoint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 33.333332,
    viewBox: "0 -960 639.99998 799.99997",
    width: 26.666666,
    fill: "#e3e3e3",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 320.06,-566.67 q 30.27,0 51.77,-21.56 21.5,-21.55 21.5,-51.83 0,-30.27 -21.56,-51.77 -21.55,-21.5 -51.83,-21.5 -30.27,0 -51.77,21.56 -21.5,21.55 -21.5,51.83 0,30.27 21.56,51.77 21.55,21.5 51.83,21.5 z M 320,-248 q 129.33,-118 191.33,-214.17 62,-96.16 62,-169.83 0,-114.86 -73.36,-188.1 -73.36,-73.23 -179.97,-73.23 -106.61,0 -179.97,73.23 -73.360001,73.24 -73.360001,188.1 0,73.67 63.000001,169.83 63,96.17 190.33,214.17 z m 0,88 Q 159,-297 79.499999,-414.5 -1.1853027e-6,-532 -1.1853027e-6,-632 q 0,-150 96.5000001853027,-239 Q 193,-960 320,-960 q 127,0 223.5,89 96.5,89 96.5,239 0,100 -79.5,217.5 Q 481,-297 320,-160 Z m 0,-480 z",
    id: "path1",
    style: {
      fill: "#1a1a1a"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPoint);
export default __webpack_public_path__ + "static/media/icon_point.8ada15928a98819aecc8d4af07d9b8d4.svg";
export { ForwardRef as ReactComponent };